import {
  GetClientAddress,
  GetComunes,
  GetExternalSubscriptionResponse,
  GetPreApproveConditionsResponse,
  PatchInsuranceIdFormResponse,
  PostClientAddress,
  PostPreApproveConditionsResponse,
} from '../../types/authorization';
import fetcher from '../../utils/fetcher';

export async function getPreApproveConditions(
  token: string,
): Promise<GetPreApproveConditionsResponse> {
  return fetcher(
    `${process.env.REACT_APP_API_URL}/pre-approve/pre-loan-request/conditions`,
    'GET',
    null,
    token,
  );
}

export async function postPreApproveConditions(
  token: string,
): Promise<PostPreApproveConditionsResponse> {
  return fetcher(
    `${process.env.REACT_APP_API_URL}/pre-approve/pre-loan-request/conditions`,
    'POST',
    null,
    token,
  );
}

export async function patchInsuranceIdForm(
  token: string,
  insuranceId: string,
  formResponse: {label: string, response: boolean}[],
): Promise<PatchInsuranceIdFormResponse> {
  return fetcher(
    `${process.env.REACT_APP_API_URL}/insurance/${insuranceId}/form`,
    'PATCH',
    { formResponse: JSON.stringify(formResponse) },
    token,
  );
}

export async function getClientAddress(token: string): Promise<GetClientAddress> {
  return fetcher(
    `${process.env.REACT_APP_API_URL}/client/address`,
    'GET',
    null,
    token,
  );
}

export async function getComunes(token: string): Promise<GetComunes> {
  return fetcher(
    `${process.env.REACT_APP_API_URL}/address/communes`,
    'GET',
    null,
    token,
  );
}

export async function postClientAddress(
  token: string,
  address: {
    addressLine1: string;
    addressLine2: string;
    communeId: string;
    zipcode: number;
  },
): Promise<PostClientAddress> {
  return fetcher(
    `${process.env.REACT_APP_API_URL}/client/address`,
    'POST',
    address,
    token,
  );
}

export async function getExternalSubscription(
  token: string,
): Promise<GetExternalSubscriptionResponse> {
  return fetcher(
    `${process.env.REACT_APP_API_URL}/external-subscription`,
    'GET',
    null,
    token,
  );
}

export async function patchSignUpSetPassword(password: string, clientToken: string) {
  await fetcher(
    `${process.env.REACT_APP_API_URL}/sign-up/set-password`,
    'PATCH',
    { password },
    clientToken,
  );
}
